<template>
    <div class="forgetPwdFrom" id="forgetPwdContent">
        <h2 class="sign-title" >{{$t('language.forgetPwd.title')}}</h2>
        <div class="font14">{{$t('language.forgetPwd.tip')}}</div>
        <div class="mc-row"  >
            <label for="" class="ic-label ic-email" :class="inputClass(selectInput.email)">
                <input type="text" name="email" class="width100" :placeholder="$t('language.popup.email')" autoComplete="off" v-model="email"
                    :class="inputClass(selectInput.email)"
                    @focus="focusInput('email')">
            </label>
            <p class="err tips-info" :class="tipsClass(selectInput.email)">{{tipsMsg.email}}</p>
        </div>
        <div class="mc-row"  >
            <label for="" class="ic-label ic-verification f-dib width68" :class="inputClass(selectInput.code)">
                <input type="text" name="verificationCode" :placeholder="$t('language.login.verificationCode')" class="width100" v-model="code"
                    :class="inputClass(selectInput.code)"
                    @focus="focusInput('code')" @blur="testCode()">
            </label>
            <div class="f-dib"><img class="sign-verificationCode" @click.stop="refreshAndClearCode()" :src="ficationCode"></div>
            <p class="err tips-info" :class="tipsClass(selectInput.code)">{{tipsMsg.code}}</p>
        </div>
        <div class="mc-row btn">
            <p class="err tips-info" :class="tipsClass(selectInput.btn)">{{tipsMsg.btn}}</p>
            <button class="login-btn" @click="forgetPwd()" :class="selectInput.btn=='sending'?'no-click':''">
                <span v-if="selectInput.btn=='sending'">{{$t('language.forgetPwd.sending')}}</span>
                <span v-else>{{$t('language.forgetPwd.btnTxt')}}</span>
            </button>
        </div>
        <div class="font13">
            <p class="f-margintop1">
                {{$t('language.forgetPwd.tips1')}} 
                <a class="alink" href="mailto:support@multcloud.com">{{$t('language.forgetPwd.tips2')}}</a> 
                {{$t('language.forgetPwd.tips3')}}
            </p>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import "@/assets/css/common_util.css";
import "@/assets/css/login_popup.css";
import loginUtil from "@/js/workspace/login_popup.js";
import constant from '../../../js/constant';
import common_util from '../../../js/workspace/common_util';

export default {
    components: {
    },
    data() {
        return {
            selectInput: {
                email: "normal",
                code: "normal",
                btn: "normal"
            },
            email: "",
            code: "",
            tipsMsg: {
                email: "",
                code: "",
                btn: "",
            },
            ficationCode: '',
            vkey: '',
            user: '',
        };
    },
    created() {

    },
    watch: {

    },
    mounted() {
        this.initPage()
    },
    methods: {
        toSignIn(){
            this.$parent.state='signIn';
        },
        //初始化注册页面
        initPage(){
            this.selectInput = {
                email: "normal",
                code: "normal",
                btn: "normal"
            },
            this.email = "",
            this.code = "",
            this.tipsMsg = {
                email: "",
                code: "",
                btn: "",
            },
            this.user="";
            this.vkey="";
            this.refreshAndClearCode();
        },
        backSignIn(){
            this.$parent.state = "signIn";
        },
        //tips获取样式（err或suc）
        tipsClass(type){
            return loginUtil.tipsClass(type);
        },
        //获取样式
        inputClass(type){
            return loginUtil.inputClass(type);
        },
        //获取焦点后清除提示
        focusInput(type){
            loginUtil.focusInput(this,type);
        },
        /* 检查格式 */
        testEmail(){
            loginUtil.testEmail(this);
        },
        testCode(){
            loginUtil.testCode(this);
        },
        //获取验证码
        refreshAndClearCode() {
            let userEmail = this.email;
            this.vkey = this.Utils.generateVerifyKey();
            this.Utils.doVerifyCodeRequest("generate", {
                params: {
                    email: userEmail //这里是请求接口书需要传的数据
                },
                responseType: 'arraybuffer', //这里是声明期望返回的数据类型
                vkey: this.vkey
            }).then(response => {
                return 'data:image/png;base64,' + btoa(new Uint8Array(response).reduce((data, email) => data + String.fromCharCode(email), ''));
            }).then(data => { //这一次箭头函数是依赖于第一次.then函数处理的data值
                this.ficationCode = data

            });
        },
        //发送忘记密码邮件
        forgetPwd(){
            this.selectInput.btn = "normal";
            this.tipsMsg.btn = "";
            //校验参数
            if(this.selectInput.btn=="sending") return;
            this.testEmail();
            if(this.selectInput.email=="error") return;
            this.testCode();
            if(this.selectInput.code=="error") return;

            //准备发送邮件
            this.selectInput.btn = "sending";
            var theLang = common_util.caseIndexLanguage(this.$i18n.locale);
            var workUrl = commonstate.nowNewUrl + (theLang == 'en' ? '' : '/' + theLang) + '/reset?code=';
            var forgotData = {
                email: this.email,
                workUrl: workUrl,
                vcode: this.code,
                vkey: this.vkey
            }

            //如果当前已存在唯一验证码，则添加多重验证唯一验证码
            if(this.$parent.dualOtp){
                if(!this.$parent.dualRember){
                    forgotData.rememberMe = false;
                }
                forgotData.otp = this.$parent.dualOtp;
                this.$parent.dualOtp = "";
            }
            this.Utils.doEmailRequest("send_forgot_code", forgotData).then(response => {
                if (response.message == "Success"&&response.status==200) {
                    this.selectInput.btn = "true";
                    this.tipsMsg.btn = "The email has been sent successfully.";
                    this.code = "";
                    this.refreshAndClearCode();
                }else{
                    if (response.reason == "verifyCodeInvalid") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = this.$t('language.login.exception.verifyCodeInvalid');
                    } else if (response.reason == "emailExist") {
                        this.selectInput.btn = "error";
                        this.tipsMsg.btn = this.$t('language.login.exception.emailExist');
                    } else if (response.exception == "unauthorizedEquipment") {
                        //进入多重验证
                        this.$parent.dual = response.dual;
                        this.$parent.dualOtp = response.otp;
                        this.$parent.backState = "forgetPwd";
                        this.$parent.getVerifyMessage("verify");
                    } else if(response.exception == "pendingActivated") {
                        //进入修改验证进行中页面
                        this.$parent.dual = response.dual;
                        this.$parent.dualOtp = response.otp;
                        this.$parent.backState = "forgetPwd";
                        this.$parent.getVerifyMessage("recovery-pending")
                    }else{
                        this.selectInput.btn = "normal";
                    }
                    this.refreshAndClearCode();
                }
            })
        },
    }
};
</script>




// WEBPACK FOOTER //
// src/components/popup/share_page_popups/forget_pwd_popup.vue